import { MediaImage } from "../media/mediaImage";


export class Search {
    // staff
    list;
    button;

    constructor() {
        this.init();
    }

    init() {
        this.list = $('.search-list');

        if (!this.list.length || this.list.length > 1) {
            return;
        }

        this.button = $('[data-container="search-list"]');

        this.bindEvents();
    }

    bindEvents() {
        this.button.on('click', (e) => {
            e.preventDefault();
            this.ajaxAction();
        });
    }

    ajaxAction() {
        const href = this.button.prop('href');
        const params = {};

        this.list.addClass('search-list--loading');

        if (!this.hasFragmentParam(href)) {
            params.fragment = true;
        }

        $.ajax({
            url: href,
            method: 'GET',
            data: params
        })
            .done((res) => {
                if (res.errors.length) {
                    this.onError(res.errors);
                    return;
                }

                this.loadItems(res);

                this.loadImages();
            })
            .fail((err) => this.onError(err))
            .always(() => this.onAlways());
    }

    loadItems(res) {
        this.list.append(res.data.html);
        res.data.nextPageUrl ? this.button.prop('href', res.data.nextPageUrl) : this.button.remove();
    }

    onError(err) {
        console.debug('Search list error ', err);
        this.list.addClass('search-list--error');
    }

    onAlways() {
        if (!this.list.is('.search-list--error')) {
            this.list.removeClass('search-list--loading');
        }
    }

    hasFragmentParam(url) {
        return /fragment=true/i.test(url);
    }

    loadImages() {
        new MediaImage();
    }
}
